/**
 * Run handlers of each plugin.
 * Stop if any of the handlers returns false.
 */
function combineHandlers(editor, ...handlers) {
  return function handleEvent(event) {
    handlers.some(handler => (handler == null ? void 0 : handler(event, editor)) === false);
  };
}

export { combineHandlers };
